import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

interface Request {
  modelId: Uuid;
}

type Response = void;

export const updatePromptModelProgress = async ({
  modelId,
}: Request): Promise<boolean> => {
  const response: Response = await sylvanus.patch(`/model/${modelId}/progress`);

  return Boolean(response);
};
